// import { gsap } from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

const $content = document.querySelector('.cases__content')
const $side = document.querySelector('.cases__side')

const mediaQuery = window.matchMedia(`(min-width: ${767.98 / 16}rem)`)

if ($content && $side && mediaQuery.matches) {
  gsap.to($side, {
    scrollTrigger: {
      trigger: $side,
      start: 'top-=145 top',
      end: `+=${$content.offsetHeight - $side.offsetHeight}`,
      pin: true,
      pinSpacing: false,
    },
  })

  const sections = document.querySelectorAll('.cases__slider')
  sections.forEach((section, index) => {
    ScrollTrigger.create({
      trigger: section,
      start: 'top center',
      end: 'bottom center',
      onEnter: () => setActiveLink(index),
      onEnterBack: () => setActiveLink(index),
    })
  })

  function setActiveLink(index) {
    const links = document.querySelectorAll('.cases__link')
    links.forEach(link => link.classList.remove('_active'))
    if (links[index]) {
      links[index].classList.add('_active')
    }
  }
}
